import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { getMasterOptions, saveProfessionalDetails, clearAccessToken } from '../api/api';
import { clearProfileCache } from '../api/profileApi';

const ProfessionalSetup = () => {
  const navigate = useNavigate();

  const [options, setOptions] = useState({
    airlines: [],
    bases: [],
    aircrafts: [],
    roles: [],
    seats: [],
  });

  const [form, setForm] = useState({
    airline_uid: '',
    base_uid: '',
    aircraft_uid: '',
    role_uid: '',
    seat_uid: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState('');

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch {}

    clearAccessToken();
    clearProfileCache();
    localStorage.removeItem('hasProfessionalProfile');
    sessionStorage.clear();
    navigate('/login', { replace: true });
  };

  useEffect(() => {
    getMasterOptions()
      .then((res) => setOptions(res.data || {}))
      .catch(() => setApiError('Failed to load options'))
      .finally(() => setLoading(false));
  }, []);

  const validate = () => {
    const newErrors = {};
    Object.keys(form).forEach((key) => {
      if (!form[key]) {
        newErrors[key] = 'This field is required';
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');

    if (!validate()) return;

    setSaving(true);
    try {
      await saveProfessionalDetails(form);
      localStorage.setItem('hasProfessionalProfile', 'true');
      window.location.replace('/calendar-setup');
    } catch {
      setApiError('Failed to save professional details');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" />
      </div>
    );
  }

  return (
  <main className="profile-screen" style={{ backgroundImage: "url(/images/profile-bg.png)" }}>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-sm-12">
            <div className="logout-btn">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  logout();
                }}
              >
                Logout
              </a>
            </div>
          </div>
        <div className="col-lg-8 col-md-10">
          
          <div className="logo-section">
              <img src="images/logo.svg" className="logo" />
          </div>

          <div className="card">
            <div className="card-body">
              <h1 className="profile-title">Set up your Profile</h1>
              <p className="profile-subtext">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>

              {apiError && (
                <div className="alert alert-danger">{apiError}</div>
              )}
<form onSubmit={handleSubmit} noValidate className="mt-4">
  <div className="row">
    {[
      { label: 'Airline', name: 'airline_uid', list: options.airlines, text: 'name' },
      { label: 'Base', name: 'base_uid', list: options.bases, text: 'airport_code' },
      { label: 'Aircraft', name: 'aircraft_uid', list: options.aircrafts, text: 'model' },
      { label: 'Role', name: 'role_uid', list: options.roles, text: 'role_name' },
      { label: 'Seat', name: 'seat_uid', list: options.seats, text: 'seat_name' },
    ].map((field, index) => {
      const hasError = Boolean(errors[field.name]);

      return (
        <div
          key={field.name}
          className={`mb-3 ${
            index < 4 ? 'col-md-6' : 'col-md-12'
          }`}
        >
          <div className="select-wrapper">
            <select
              name={field.name}
              value={form[field.name]}
              onChange={handleChange}
              className={`form-select form_select custom-select`}
            >
              <option value="">Select {field.label}</option>
              {field.list?.map((item) => (
                <option key={item.uid} value={item.uid}>
                  {item[field.text]}
                </option>
              ))}
            </select>
          </div>
            {hasError && (
              <div className="invalid-feedback d-block">
                {errors[field.name]}
              </div>
            )}
          
        </div>
      );
    })}
  </div>

  <button
    type="submit"
    className="btn-style1 btn2 mt-4"
    disabled={saving}
  >
    {saving ? 'Saving...' : 'Next'}
  </button>
</form>


{/* 
              <form onSubmit={handleSubmit} noValidate>
                {[
                  { label: 'Airline', name: 'airline_uid', list: options.airlines, text: 'name' },
                  { label: 'Base', name: 'base_uid', list: options.bases, text: 'airport_code' },
                  { label: 'Aircraft', name: 'aircraft_uid', list: options.aircrafts, text: 'model' },
                  { label: 'Role', name: 'role_uid', list: options.roles, text: 'role_name' },
                  { label: 'Seat', name: 'seat_uid', list: options.seats, text: 'seat_name' },
                ].map((field) => (
                  <div className="mb-3" key={field.name}>
    
                    <div className="select-wrapper">
                      <select
                        name={field.name}
                        value={form[field.name]}
                        onChange={handleChange}
                        className={`form-select form_select custom-select ${
                          errors[field.name] ? 'is-invalid' : ''
                        }`}
                      >
                        <option value="">Select {field.label}</option>
                        {field.list?.map((item) => (
                          <option key={item.uid} value={item.uid}>
                            {item[field.text]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="invalid-feedback">
                      {errors[field.name]}
                    </div>
                  </div>
                ))}

                <button
                  type="submit"
                  className="btn-style1 mt-4"
                  disabled={saving}
                >
                  {saving ? 'Saving...' : 'Save and Continue'}
                </button>
              </form> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  );
};

export default ProfessionalSetup;
